import cloneDeep from 'lodash/cloneDeep';

export default function collectEnabledFilters(filters, user) {
    const newFilters = cloneDeep(filters);
    if (!user || !user.exists) {
        delete newFilters.status;
    } else {
        const keyPrefixToDelete = user.actsAsAdmin ? 'user_' : 'admin_';
        Object.keys(newFilters.status).forEach((key) => {
            if (key.startsWith(keyPrefixToDelete)) {
                delete newFilters.status[key];
            }
        });
    }

    return newFilters;
}
